import { DayTimetable, IntervalTimetable, TimeInterval, WeekTimetable, } from 'z3k-config';
import { seemsLikeObjectId } from 'z3k-parser/lib';
function removeDay(config, day_id, addIdToBlacklist) {
    const newConfig = DayTimetable.get.removeById(config, day_id);
    if (newConfig != config) {
        addIdToBlacklist(day_id);
    }
    return newConfig;
}
export function removeWeek(config, week_id, addIdToBlacklist) {
    const week = WeekTimetable.get.byId(config, week_id);
    if (!week) {
        return config;
    }
    addIdToBlacklist(week_id);
    week.temp7.forEach(addIdToBlacklist);
    return week.temp7.reduce(DayTimetable.get.removeById, WeekTimetable.get.removeById(config, week_id));
}
function removeIntervalTimetable(config, interval_id, addIdToBlacklist) {
    const timetable = IntervalTimetable.get.byId(config, interval_id);
    if (!timetable) {
        return config;
    }
    addIdToBlacklist(timetable.id);
    timetable.time_intervals.forEach(addIdToBlacklist);
    return timetable.time_intervals.reduce(TimeInterval.get.removeById, IntervalTimetable.get.removeById(config, interval_id));
}
export function removeTemperatureSetting(config, id2Delete, addIdToBlacklist) {
    if (!seemsLikeObjectId(id2Delete)) {
        return config;
    }
    return removeIntervalTimetable(removeWeek(removeDay(config, id2Delete, addIdToBlacklist), id2Delete, addIdToBlacklist), id2Delete, addIdToBlacklist);
}
